// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__hjQ7v","header":"Cart_header__ErU1q","title":"Cart_title__jTTV9","footer":"Cart_footer__20YXw"};